import { DRIVER_REJECTION_REASONS } from "@repo/types";
import { useTranslation } from "react-i18next";
import { RejectionDialogButton } from "@/components/common/RejectionModal";
import type { ReasonObject } from "@/libs/generated/types";

type DriverRejectionDialogButtonProps = {
  buttonText?: string;
  description?: string;
  icon?: React.ElementType;
  loading?: boolean;
  disabled?: boolean;
  onConfirm: (reason: ReasonObject) => void;
};

/** Driver rejection, configured on top of the generic rejection dialog. */
export function DriverRejectionDialogButton({
  buttonText,
  description,
  icon,
  loading,
  disabled,
  onConfirm,
}: DriverRejectionDialogButtonProps) {
  const { t } = useTranslation();

  return (
    <RejectionDialogButton
      buttonText={buttonText ?? t("common.reject")}
      title={t("common.confirmation-reject-title")}
      description={description ?? t("common.confirmation-reject")}
      reasonLabel={t("driver.rejectReason.label")}
      reasonOptions={DRIVER_REJECTION_REASONS.map((value) => ({
        value,
        label: t(`driver.rejectReason.${value}`),
      }))}
      additionalInfoLabel={t("driver.rejectReason.additionalInfo")}
      confirmLabel={t("common.reject")}
      cancelLabel={t("common.actions.cancel")}
      icon={icon}
      loading={loading}
      disabled={disabled}
      onConfirm={onConfirm}
    />
  );
}
